var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _g4, _g5, _path10, _path11, _path12, _g6, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullseye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_715_14839)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 12.0391,
    fill: "url(#paint0_linear_715_14839)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 12.0391,
    fill: "url(#paint1_radial_715_14839)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 8.80469,
    fill: "url(#paint2_linear_715_14839)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 8.80469,
    fill: "url(#paint3_radial_715_14839)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 8.80469,
    fill: "url(#paint4_radial_715_14839)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 5.75781,
    fill: "url(#paint5_linear_715_14839)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 5.75781,
    fill: "url(#paint6_radial_715_14839)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 2.85938,
    fill: "#B7ABC8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 2.85938,
    fill: "url(#paint7_radial_715_14839)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0391,
    cy: 17.9609,
    r: 2.85938,
    fill: "url(#paint8_radial_715_14839)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_14839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.281 28.9294C20.3387 28.9294 25.2494 24.0186 25.2494 17.9609C25.2494 11.9032 20.3387 6.99243 14.281 6.99243C8.22325 6.99243 3.3125 11.9032 3.3125 17.9609C3.3125 24.0186 8.22325 28.9294 14.281 28.9294Z",
    stroke: "url(#paint9_linear_715_14839)",
    strokeWidth: 0.65
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 17.875C13.7949 17.5364 13.6699 17.1516 14.0085 16.813L15.7235 15.0901C16.0621 14.7515 16.611 14.7515 16.9495 15.0901C17.2881 15.4287 17.2881 15.9776 16.9495 16.3161L15.2345 18.039C14.896 18.3776 14.472 18.2135 14.1334 17.875Z",
    fill: "#7C7088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 17.875C13.7949 17.5364 13.6699 17.1516 14.0085 16.813L15.7235 15.0901C16.0621 14.7515 16.611 14.7515 16.9495 15.0901C17.2881 15.4287 17.2881 15.9776 16.9495 16.3161L15.2345 18.039C14.896 18.3776 14.472 18.2135 14.1334 17.875Z",
    fill: "url(#paint10_linear_715_14839)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 17.875C13.7949 17.5364 13.6699 17.1516 14.0085 16.813L15.7235 15.0901C16.0621 14.7515 16.611 14.7515 16.9495 15.0901C17.2881 15.4287 17.2881 15.9776 16.9495 16.3161L15.2345 18.039C14.896 18.3776 14.472 18.2135 14.1334 17.875Z",
    fill: "url(#paint11_linear_715_14839)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6651 2.77189L23.8922 6.01562L19.4078 9.15625C18.0726 5.62482 19.7056 3.53913 21.2213 2.33023C21.7184 1.93373 22.4401 2.17716 22.6651 2.77189Z",
    fill: "#2983DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6651 2.77189L23.8922 6.01562L19.4078 9.15625C18.0726 5.62482 19.7056 3.53913 21.2213 2.33023C21.7184 1.93373 22.4401 2.17716 22.6651 2.77189Z",
    fill: "url(#paint12_radial_715_14839)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6651 2.77189L23.8922 6.01562L19.4078 9.15625C18.0726 5.62482 19.7056 3.53913 21.2213 2.33023C21.7184 1.93373 22.4401 2.17716 22.6651 2.77189Z",
    fill: "url(#paint13_linear_715_14839)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1976 9.31135L25.939 8.12427L22.8539 12.647C26.4015 13.9387 28.4669 12.28 29.657 10.7496C30.0474 10.2476 29.7951 9.529 29.1976 9.31135Z",
    fill: "#2980EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1976 9.31135L25.939 8.12427L22.8539 12.647C26.4015 13.9387 28.4669 12.28 29.657 10.7496C30.0474 10.2476 29.7951 9.529 29.1976 9.31135Z",
    fill: "url(#paint14_linear_715_14839)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1976 9.31135L25.939 8.12427L22.8539 12.647C26.4015 13.9387 28.4669 12.28 29.657 10.7496C30.0474 10.2476 29.7951 9.529 29.1976 9.31135Z",
    fill: "url(#paint15_radial_715_14839)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_14839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3223,
    y: 2.62402,
    width: 0.945538,
    height: 5.25761,
    rx: 0.472769,
    transform: "rotate(-20.5233 21.3223 2.62402)",
    fill: "url(#paint16_radial_715_14839)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_14839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.6426,
    y: 9.72046,
    width: 0.945537,
    height: 5.25761,
    rx: 0.472769,
    transform: "rotate(110.612 29.6426 9.72046)",
    fill: "url(#paint17_radial_715_14839)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_715_14839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 10.7097L23.3055 5.80015C24.1845 5.14295 25.4987 5.31421 26.162 5.99724C26.8992 6.78842 26.9866 7.95329 26.3542 8.81272L21.4643 15.4582C20.236 17.1276 17.8141 17.3228 16.3343 15.8716C14.8426 14.4089 15.0065 11.9606 16.6797 10.7097Z",
    fill: "#52BCF0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 10.7097L23.3055 5.80015C24.1845 5.14295 25.4987 5.31421 26.162 5.99724C26.8992 6.78842 26.9866 7.95329 26.3542 8.81272L21.4643 15.4582C20.236 17.1276 17.8141 17.3228 16.3343 15.8716C14.8426 14.4089 15.0065 11.9606 16.6797 10.7097Z",
    fill: "url(#paint18_radial_715_14839)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 10.7097L23.3055 5.80015C24.1845 5.14295 25.4987 5.31421 26.162 5.99724C26.8992 6.78842 26.9866 7.95329 26.3542 8.81272L21.4643 15.4582C20.236 17.1276 17.8141 17.3228 16.3343 15.8716C14.8426 14.4089 15.0065 11.9606 16.6797 10.7097Z",
    fill: "url(#paint19_radial_715_14839)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 10.7097L23.3055 5.80015C24.1845 5.14295 25.4987 5.31421 26.162 5.99724C26.8992 6.78842 26.9866 7.95329 26.3542 8.81272L21.4643 15.4582C20.236 17.1276 17.8141 17.3228 16.3343 15.8716C14.8426 14.4089 15.0065 11.9606 16.6797 10.7097Z",
    fill: "url(#paint20_radial_715_14839)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_715_14839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.0234,
    y: 4.74194,
    width: 1.76803,
    height: 9.03771,
    rx: 0.884013,
    transform: "rotate(45 26.0234 4.74194)",
    fill: "#2984E4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.0234,
    y: 4.74194,
    width: 1.76803,
    height: 9.03771,
    rx: 0.884013,
    transform: "rotate(45 26.0234 4.74194)",
    fill: "url(#paint21_radial_715_14839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_715_14839",
    x: 2,
    y: 5.42188,
    width: 24.5781,
    height: 25.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.160784 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14839"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.341176 0 0 0 0 0.490196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_14839",
    result: "effect2_innerShadow_715_14839"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_14839",
    x: 2.33828,
    y: 6.01748,
    width: 23.8859,
    height: 23.8869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.325,
    result: "effect1_foregroundBlur_715_14839"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_14839",
    x: 20.957,
    y: 1.92822,
    width: 3.45898,
    height: 5.98413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_14839"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_14839",
    x: 24.0254,
    y: 7.50562,
    width: 5.98047,
    height: 3.46387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_14839"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_715_14839",
    x: 15.3125,
    y: 5.38672,
    width: 11.7148,
    height: 11.7095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.45098 0 0 0 0 0.65098 0 0 0 0 0.737255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14839"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_715_14839",
    x: 19.848,
    y: 4.95815,
    width: 7.21016,
    height: 7.20845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.521569 0 0 0 0 0.764706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14839"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.225
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.435294 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_14839",
    result: "effect2_innerShadow_715_14839"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_14839",
    x1: 19.5336,
    y1: 7.12135,
    x2: 9.43309,
    y2: 27.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6378B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3A5C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9723 10.3297) rotate(124.825) scale(5.33467 7.75809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219108,
    stopColor: "#B82974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82974",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_14839",
    x1: 20.3531,
    y1: 22.3885,
    x2: 7.2788,
    y2: 8.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5BCD3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2138 17.9609) scale(11.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86129,
    stopColor: "#CBC4DF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC4DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1952 9.75851) rotate(118.217) scale(5.90623 3.23274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA8B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_14839",
    x1: 17.8779,
    y1: 14.0743,
    x2: 11.0868,
    y2: 23.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2347A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3963"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9893 14.2647) rotate(131.253) scale(4.47426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#962359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947427,
    stopColor: "#962359",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4986 16.9938) rotate(67.2035) scale(4.75032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.612995,
    stopColor: "#C9BED9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9BED9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3392 15.1016) rotate(103.843) scale(3.71373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#857D97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_14839",
    x1: 23.4195,
    y1: 10.7826,
    x2: 16.8281,
    y2: 17.5236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6AA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_14839",
    x1: 16.1473,
    y1: 17.2809,
    x2: 15.506,
    y2: 16.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5F8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_14839",
    x1: 14.8998,
    y1: 15.8232,
    x2: 15.1381,
    y2: 16.0475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746D7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5798 6.15625) rotate(-157.278) scale(2.71034 4.92096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.749676,
    stopColor: "#6897C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6897C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_14839",
    x1: 23.4705,
    y1: 4.3125,
    x2: 21.8767,
    y2: 4.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_14839",
    x1: 28.1268,
    y1: 8.5312,
    x2: 27.533,
    y2: 9.81245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6268 9.23433) rotate(79.5793) scale(4.14652 5.34146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.814441,
    stopColor: "#5066D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92639,
    stopColor: "#5066D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8257 2.94692) rotate(86.9247) scale(4.99592 1.05482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.146 10.0434) rotate(86.9247) scale(4.99592 1.05482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1565 5.875) rotate(143.326) scale(3.66252 3.77403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.422676,
    stopColor: "#6BFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0061 8.54593) rotate(137.684) scale(10.8469 10.9883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.837515,
    stopColor: "#5E9BDB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E9BDB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8936 11.1165) rotate(134.318) scale(1.97052 1.03686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.360543,
    stopColor: "#49A0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_715_14839",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8302 5.62583) rotate(-89.5692) scale(2.939 1.11952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60CAFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/Bullseye.101321131c56840689441bac3eb79982.svg";
export { ForwardRef as ReactComponent };